export default "__VITE_ASSET__Ch85WNEl__"